function initLightBoxSwiper (){

  var enqureBtn = document.getElementById("product-image-zoom-btn"),
      enqurePopup = document.getElementById("enquiry-popup"),
      enqurePopupIn = document.getElementById("popup-in");
      var swiperContainer = document.querySelector(".mySwiper"); 

  if (enqureBtn) {
    enqureBtn.addEventListener("click", function (e) {
      var t = document.querySelector(".product-gallery__thumbnail-list");
      if (t) {
        var o = t.querySelectorAll("a");
        for (var n = 0; n < o.length; n++) {
          if (o[n].classList.contains("is-nav-selected")) {
            var i = o[n].querySelector("img").getAttribute("data-imgcount") -1;
            if(window.lightBoxSwiper ){
              window.lightBoxSwiper.slideTo(i);
            }
            break;
          }
        }
      }
      e.preventDefault();
      enqurePopup.classList.add("open");
      document.body.classList.add("popup-open");
    });
  }

  if (enqurePopup) {
    enqurePopup.addEventListener("click", function (e) {
      if (!(e.target === enqurePopupIn || enqurePopupIn.contains(e.target))) {
        enqurePopup.classList.remove("open");
        document.body.classList.remove("popup-open");
      }
    });
  }

  const popupClose = document.getElementById("popup-btn-close");
  if (popupClose) {
    popupClose.addEventListener("click", function (e) {
      e.preventDefault();
      enqurePopup.classList.remove("open");
      document.body.classList.remove("popup-open");
    });
  } 

  if (swiperContainer) {
    if(window.lightBoxSwiper){
      window.lightBoxSwiper.destroy();
    }
    window.lightBoxSwiper = new Swiper(swiperContainer, {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      centeredSlides: true,
      centeredSlidesBounds: true,
    });
  }
}
initLightBoxSwiper();